/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Scope_MembersInputs */

const en_us2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members only`)
};

const pt_br2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só os membros`)
};

const es_419_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo miembros`)
};

const pt_pt2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só os membros`)
};

const fr_fr2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres uniquement`)
};

const de_de2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Mitglieder`)
};

const it_it2_clubs_scope_members = /** @type {(inputs: Clubs_Scope_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo i membri`)
};

/**
* | output |
* | --- |
* | "Members only" |
*
* @param {Clubs_Scope_MembersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_scope_members = /** @type {((inputs?: Clubs_Scope_MembersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Scope_MembersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_scope_members(inputs)
	if (locale === "es-419") return es_419_clubs_scope_members(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_scope_members(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_scope_members(inputs)
	if (locale === "de-DE") return de_de2_clubs_scope_members(inputs)
	if (locale === "it-IT") return it_it2_clubs_scope_members(inputs)
	return en_us2_clubs_scope_members(inputs)
});
export { clubs_scope_members as "clubs.scope_members" }